import {createContext} from 'react'

export default createContext({
  mode: undefined,
  setMode: _ => {},
  catTitle: undefined,
  setCatTitle: _ => {},
})
